var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.16 36.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5",
    "data-name": "\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,.94h9.21v35.25H0V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.99.94h9.21v28.2h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72.94h19.32v8.13h-5.03v20.07h-9.21V9.07h-5.08V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.16,12.83v16.35h-9.21V13.02c0-2.54-1.93-4.56-4.42-4.56s-4.42,2.02-4.42,4.56v16.12h-9.21V12.83c0-7.75,6.16-12.83,13.63-12.83s13.63,5.12,13.63,12.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/חזוןmdpi.9bfd3e6356670de650f904ec8e6daeec.svg";
export { ForwardRef as ReactComponent };